import React from "react";
import "../Styles/footer.css";
import logo from "../assets/logo.jpg";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-div1">
        <div className="footer-div1-item  footer-div1-items">
          <img src={logo} alt="logo" />
          <p>
            Technology that saves lives. Real-time <br />
            emergency response and vaccine monitoring <br />
            for every community.
          </p>
        </div>
        <div className=" footer-div1-items">
          <p style={{ color: "#FFD700" }}>Solutions</p>
          <ul>
            <li>Emergency Response</li>
            <li>Vaccine Monitoring</li>
            <li>Hospital Locator </li>
            <li>Cold Chain Protection</li>
          </ul>
        </div>
        <div className="footer-div1-items">
          <p style={{ color: "#FFD700" }}>Resources </p>
          <ul>
            <li>Documentation</li>
            <li>API Reference</li>
            <li>Case Studies</li>
            <li>Support</li>
          </ul>
        </div>
        <div className=" footer-div1-items">
          <p style={{ color: "#FFD700" }}> Contact </p>
          <ul>
            <li>About Us</li> <li>Our Services</li>{" "}
            <li>
              Contact Us: partnerships@lifebox.health <br /> +1 (555) 123-LIFE
              <br />
              Global Operations
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-div2">
        <hr className="hr"></hr>
        <div className="tandc">
          <span> © 2024 LifeBox. All rights reserved.</span>
          <span>Terms of use Privacy</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
